/* eslint-disable import/prefer-default-export */
export const GET_ANALYTICS_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
